export const rosterSelector = (state) => state.rosterReducer.roster;
export const lockRosterSelector = (state) => state.rosterReducer.lockRoster;
export const previousRosterSelector = (state) =>
  state.rosterReducer.previousRoster;
